
import { useEffect } from 'react';

interface PreloadResource {
  href: string;
  as: string;
  type?: string;
  crossorigin?: string;
}

const ResourcePreloader = () => {
  useEffect(() => {
    // Preload critical resources
    const preloadResources: PreloadResource[] = [
      // Critical fonts (if you add any custom fonts)
      // { href: '/fonts/inter.woff2', as: 'font', type: 'font/woff2', crossorigin: 'anonymous' },
      
      // Critical images for homepage
      { href: '/favicon.ico', as: 'image' },
    ];

    preloadResources.forEach(resource => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = resource.href;
      link.as = resource.as;
      if (resource.type) link.type = resource.type;
      if (resource.crossorigin) link.crossOrigin = resource.crossorigin;
      
      document.head.appendChild(link);
    });

    // Preconnect to external domains
    const preconnectDomains = [
      'https://www.googletagmanager.com',
      'https://images.unsplash.com',
      'https://cdn.gpteng.co',
    ];

    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      document.head.appendChild(link);
    });

    // DNS prefetch for other domains
    const dnsPrefetchDomains = [
      'https://www.google-analytics.com',
    ];

    dnsPrefetchDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'dns-prefetch';
      link.href = domain;
      document.head.appendChild(link);
    });
  }, []);

  return null;
};

export default ResourcePreloader;
